module.exports = __webpack_public_path__ + "img/cz.2c6daf40.svg";